const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class MedievalArmy extends Tactic {
    constructor() {
        super(
            Age.Age1,
            TacticNames.MedievalArmy,
            [1, 1, 0],
            "2",
            {}
        )
    }
}

module.exports = MedievalArmy;